import Hero from "../components/Hero";
import Skills from "../components/Skills";

export default function Home() {
  return (
    <>
      <Hero />
      <Skills />
    </>
  );
}
